import { blackColors, primaryColor } from 'assets/jss/material-dashboard-pro-react';

const addNumberDialogStyle = (theme) => ({
	dialog: {
		'& .MuiPaper-root': {
			width: '642px',
			height: '642px',
		},
	},
	dialogBody: {
		padding: '0 32px',
		[theme.breakpoints.down('xs')]: {
			padding: '0 16px',
		},
	},
	filters: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'flex-end',
		marginTop: '10px',
		[theme.breakpoints.down('xs')]: {
			flexDirection: 'column',
			alignItems: 'flex-start',
			justifyContent: 'flex-start',
		},
		'& > div': {
			'&:first-of-type': {
				width: '260px',
				maxWidth: '80%',
			},
			'&:last-of-type': {
				'& .MuiFormControlLabel-root': {
					marginRight: 0,
				},
				'& .MuiFormControlLabel-label': {
					position: 'relative',
					bottom: '-2px',
				},
			},
		},
	},
	confirmationDialogBody: {},
	changingDepartmentInfo: {
		marginTop: '30px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		flexWrap: 'wrap',
		'& div': {
			textAlign: 'center',
		},
		'& > p': {
			marginTop: '3px',
			marginRight: '10px',
		},
		'& svg': {
			width: '16px',
			height: 'auto',
			color: blackColors[3],
		},
	},
	arrowForwardIcon: {
		marginRight: '2px',
	},
	phoneIcon: {
		marginRight: '4px',
	},
	confirmationDialog: {
		'& .MuiDialog-paper': {
			width: '486px',
		},
	},
	numbersGroup: {
		marginBottom: '20px',
		'& svg': {
			width: '16px',
			height: 'auto',
			color: blackColors[3],
			marginRight: '8px',
			marginBottom: '1px',
		},
		'& > div': {
			'&:first-of-type': {
				display: 'flex',
				alignItems: 'flex-end',
				marginBottom: '12px',
			},
			'&:last-of-type': {
				marginLeft: '30px',
				'& > div': {
					display: 'flex',
					alignItems: 'flex-end',
					marginBottom: '8px',
				},
			},
		},
	},
	notAdded: {
		color: `${primaryColor[0]}!important`,
	},
	additionalMargin: {
		marginBottom: '20px',
	},
	cellCaption: {
		margin: 0,
	},
});

export default addNumberDialogStyle;
